import React, { useState } from "react";
import PropTypes from "prop-types";
import { isIOS, openSkopicApp } from "src/Utils/deviceDetection";
import "./MobileInviteLandingPage.css";

const MobileInviteLandingPage = ({ communityName, onOpenInBrowser, emailActionData }) => {
  const [installError, setInstallError] = useState(null);

  const handleOpenAppClick = (e) => {
    e.preventDefault();
    setInstallError(null);

    try {
      openSkopicApp({ communityName, emailActionData });
    } catch (err) {
      console.error("Error opening app or store URL:", err);
      setInstallError("Unable to open app store.");
    }
    if (onOpenInBrowser) {
      onOpenInBrowser();
    }
  };

  const handleCancelClick = (e) => {
    e.preventDefault();
    try {
      if (onOpenInBrowser) {
        onOpenInBrowser();
      }
    } catch (err) {
      console.error("Error continuing in browser:", err);
    }
  };

  const storeName = isIOS() ? "AppStore" : "PlayStore";

  return (
    <div className="mobile-invite-overlay" id="mobile-invite-system-dialog-overlay">
      <div className="mobile-invite-system-dialog" role="dialog" aria-modal="true">
        <div className="system-dialog-content">
          <h3 className="system-dialog-title">Open in &quot;{storeName}&quot;?</h3>
          {installError && (
            <div className="system-dialog-error">
              {installError}
            </div>
          )}
        </div>

        <div className="system-dialog-actions">
          <button
            type="button"
            className="system-dialog-btn system-dialog-btn-cancel"
            onClick={handleCancelClick}
            id="mobile-dialog-cancel-btn"
          >
            Cancel
          </button>
          <button
            type="button"
            className="system-dialog-btn system-dialog-btn-open"
            onClick={handleOpenAppClick}
            id="mobile-dialog-open-btn"
          >
            Open
          </button>
        </div>
      </div>
    </div>
  );
};

MobileInviteLandingPage.propTypes = {
  communityName: PropTypes.string,
  onOpenInBrowser: PropTypes.func.isRequired,
  emailActionData: PropTypes.object,
};

export default MobileInviteLandingPage;
